import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";

export default function KakaoAuthRedirect() {
  const { signInWithKakao, currentUser, getToken } = useAuth();
  useEffect(() => {
    async function getAccessToken() {
      const botId = window.localStorage.getItem("kakaoBotId");
      const code = new URL(window.location.href).searchParams.get("code");
      const redirect = new URL(window.location.href).searchParams.get("redirect");

      try {
        await signInWithKakao(code, botId, `/oauth/callback/kakao?redirect=${redirect}`);
        window.location.href = redirect;
        //"/oauth/complete";
      } catch (error) {
        alert(error.message);
        console.log(error);
      }
    }

    getAccessToken();

  }, []);

  // useEffect(() => {    
  //   if (currentUser) {
  //     window.location.href = "/oauth/complete";
  //   }
  // }, [currentUser]);

  return (
    <div className="h-screen w-full flex flex-col justify-center items-center">
      <img src="/assets/gifs/loading.gif" alt="loading" className="w-1/2 mb-5" />
      <h1 className="text-2xl font-bold">로그인 진행중...</h1>
    </div>
  );
}